import '.c0{position:relative;}.ssr-plugin'
import '.o{width:100%;}.ssr-plugin'
import '.gb{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.cf{align-items:flex-start;}.ssr-plugin'
import '.q{padding:2rem;}.ssr-plugin'
import '.cp{background:var(--shades-white);}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.is{top:50%;}.ssr-plugin'
import '.it{right:1rem;}.ssr-plugin'
import '.iu{transform:translateY(-50%);}.ssr-plugin'
import '.iv{width:120px;}.ssr-plugin'
import '.iw{height:120px;}.ssr-plugin'
import '.ix{z-index:0;}.ssr-plugin'
import '.k{align-items:center;}.ssr-plugin'
import '.ht{z-index:1;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.iy{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c0 o gb a b a1 cf q cp aa"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="a6 is it iu iv iw ix a k a1"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c0 ht a b cf al iy"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
